/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Chkk Admin API v1.0
 * Chkk Admin API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * ???
 */
export type ClusterStatus = (typeof ClusterStatus)[keyof typeof ClusterStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterStatus = {
  active: 'active',
  deactivated: 'deactivated',
} as const;
